module.exports = __webpack_public_path__ + "static/media/6.question.e4790cd3.mp4";